import { UiKitRatingBlock } from '@/fo/ui/kit/rating/block';
import { ReviewsData } from '@/fo/ui/review/catalog/base';
import { UiReviewGalleryBase } from '@/fo/ui/review/gallery/base';
import { UiReviewRecommendPercent } from '@/fo/ui/review/recommend/percent';

import { styles } from './ReviewsHeader.styles';

export interface ReviewsHeaderProps {
  reviewsData: ReviewsData;
  onImageClick?: (imageId: string) => void;
  className?: string;
}

export function ReviewsHeader({
  reviewsData,
  onImageClick,
  className
}: ReviewsHeaderProps) {
  const slots = styles();
  const hasImages = reviewsData.images && reviewsData.images.length > 0;

  return (
    <div className={slots.container({ className })}>
      <div className={slots.ratingBlock()}>
        <UiKitRatingBlock value={reviewsData.rating} />
        <UiReviewRecommendPercent percent={reviewsData.recommendPercent} />
      </div>

      {hasImages && (
        <UiReviewGalleryBase
          images={reviewsData.images}
          onImageClick={onImageClick}
        />
      )}
    </div>
  );
}
